<div class="review-anticipated-expenditures">

    <ng-container *ngIf="!anticipatedExpenditures || anticipatedExpenditures.length === 0">
        <div class="no-expenditures-container">
            <i class="fa fa-check"></i>
            There are no {{previousFiscalYear?.yearRange}} expenditures to review, continue to the next step.
        </div>
    </ng-container>

    <ng-container *ngIf="anticipatedExpenditures && anticipatedExpenditures.length > 0">

        <div class="row margin-bottom-40">
            <div class="col-md-12">
                <div class="margin-top-20 text-center">
                    <h4>Indicate when the following {{ 'components' | terminology | async }} will be replaced</h4>
                </div>
            </div>
        </div>

        <div class="text-end">
            <button class="btn btn-success-inverted margin-left-10" (click)="setForAll(false)"> Replace all in {{previousFiscalYear?.yearRange}}</button>
            <button class="btn btn-success-inverted margin-left-10" (click)="setForAll(true)"> Replace all in {{selectedYearDisplay}}</button>
        </div>
        <div class="row grid-header margin-top-10">
            <div class="col-md-8 text-start"><span>NAME</span></div>
            <div class="col-md-2"></div>
            <div class="col-md-2"></div>
        </div>

        <!-- <p class="text-muted font-light margin-top-10">If the component has already been replaced or will be delayed beyond {{selectedYearDisplay}}, click the name below to edit that component.</p> -->
        <ng-container *ngFor="let component of anticipatedExpenditures; trackBy: trackByComponentId">

            <div class="row component-row">
                <div class="col-md-8">
                    <a tabindex="0" class="cursor-pointer" (click)="editComponent(component)" [innerHTML]="component.name | truncate : 50 : ''"></a>
                </div>
                <div class="col-md-4 text-end">
                    <span>Replace in</span>
                    <label class="btn-radio-container">
                        <input type="radio"
                            [name]="component.propertyComponentId"
                            [value]="true"
                            [checked]="isReplacementDelayed(component.propertyComponentId) !== true"
                            (change)="componentReplacementChanged(component.propertyComponentId, false)" >
                        <span></span> {{previousFiscalYear?.yearRange}}
                    </label>
                    <label class="btn-radio-container">
                        <input type="radio"
                            [name]="component.propertyComponentId"
                            [value]="false"
                            [checked]="isReplacementDelayed(component.propertyComponentId) === true"
                            (change)="componentReplacementChanged(component.propertyComponentId, true)" >
                        <span></span> {{selectedYearDisplay}}
                    </label>
                </div>
            </div>
        </ng-container>

        <div class="text-end margin-top-10" *ngIf="extendLifeComponents.length > 0">
            <input type="checkbox" [(ngModel)]="updateCurrentYear" id="update-current-year-components">
            <label for="update-current-year-components">Update anticipated expenditures for <span class="font-bold">{{previousFiscalYear?.yearRange}} year</span> to reflect modifications above?</label>
        </div>
    </ng-container>
</div>
